import React, {useState, useEffect, useContext} from "react";
import {
  UnorderedList,
  ListItem,
  Grid,
  GridItem,
  SimpleGrid,
  Button,
  Container,
  VStack,
} from '@chakra-ui/react';
import {client} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"
import {useNavigate} from "react-router-dom";

export const Menu = () => {
  const [text, setText] = useState("");
  const [currentUserX, setCurrentUserX] = useState("")

  const {globalState, setGlobalState} = useContext(GlobalContext);
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      const resp = await client.home({bearerToken: bearerToken()});
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})

      if (resp.currentUser && resp.currentUser.optRole === "student") {
        navigate(`/students/${resp.currentUser.id}/works`, {relative: "path"})
      }
      setCurrentUserX(resp.currentUser?.optName ?? "Guest")
      setText(resp.text);
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const logout = () => {
    navigate("/mlogout")
  }
  return <Page>
    <PageHeader title={"メニュー"}></PageHeader>
    <PageBody>
      <Container>
        <VStack spacing={6}>
          <Grid w='100%' templateColumns='repeat(2, 1fr)' gap={6}>
            <GridItem colSpan={2}><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate(`./vendors/${globalState.currentUser.optVendorId}/students`)}}>生徒一覧</Button></GridItem>
            <GridItem colSpan={2}><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate('./coursewares')}}>教材参照</Button></GridItem>
            { (globalState.currentUser.optRole === "admin" || globalState.currentUser.optRole === "vendor") && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate(`./vendors/${globalState.currentUser.optVendorId}/teachers`)}}>先生一覧</Button></GridItem> }
            { (globalState.currentUser.optRole === "admin" || globalState.currentUser.optRole === "vendor") && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate(`./vendors/${globalState.currentUser.optVendorId}/schoolrooms`, { relative: "path" })}}>教室一覧</Button></GridItem> }
            { globalState.currentUser.optRole === "admin" && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate("./registration")}}>教材管理</Button></GridItem> }
            { globalState.currentUser.optRole === "admin" && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate(`./vendors/${globalState.currentUser.optVendorId}/groupworks`)}}>グループ教材管理</Button></GridItem> }
            { globalState.currentUser.optRole === "admin" && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate("./vendors", { relative: "path" })}}>事業者一覧</Button></GridItem> }
            {/* Show the entity only when globalState.currentUser.optRole is “admin” */}
            { globalState.currentUser.optRole === "admin" && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate("./admins", { relative: "path" })}}>管理者一覧</Button></GridItem> }
            { globalState.currentUser.optRole === "admin" && <GridItem><Button size="lg" isDisabled={false} w={'100%'} onClick={() => {navigate("./logs", { relative: "path" })}}>ログ</Button></GridItem> }
          </Grid>
          <Button w={'50%'} onClick={logout}>ログアウト</Button>
        </VStack>
      </Container>
    </PageBody>
  </Page>
}
